import { Route, Routes } from 'react-router-dom';

import { AnnouncementForm } from '../AnnouncementForm';
import { AnnouncementList } from '../AnnouncementList';
import { VersionCardForm } from '../VersionCardForm';

export function AnnouncementsSection() {
  return (
    <Routes>
      <Route index element={<AnnouncementList />} />
      <Route path="version-card/new" element={<VersionCardForm />} />
      <Route path=":id" element={<AnnouncementForm />} />
    </Routes>
  );
}
